import { apiService } from '../api/ApiService';

const API_BASE = '/api/public/languages';

export type Language = {
    id: string;
    name: string;
    isoName: string;
    flag: string;
};

type PublicLanguagesResponse = {
    languages: Language[];
};

class LanguageService {
    public async getAllLanguages(): Promise<Language[]> {
        const payload = await apiService.request<PublicLanguagesResponse>(API_BASE);

        if (!payload || !Array.isArray(payload.languages)) {
            throw new Error('Invalid public languages API shape');
        }

        return payload.languages;
    }
}

export const languageService = new LanguageService();
